import { render, staticRenderFns } from "./SidebarImportInvoices.vue?vue&type=template&id=705a9744&scoped=true"
import script from "./SidebarImportInvoices.vue?vue&type=script&lang=js"
export * from "./SidebarImportInvoices.vue?vue&type=script&lang=js"
import style0 from "./SidebarImportInvoices.vue?vue&type=style&index=0&id=705a9744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a9744",
  null
  
)

export default component.exports